// MenuRSStateStore.ts
import create from 'zustand';
import { persist } from 'zustand/middleware';

interface useMenuUsersStateStore {
    selectedStateMenuUsers: string;
    setSelectedStateMenuUsers: (uid: string) => void;
}

export const useMenuUsersState = create<useMenuUsersStateStore>()(
    persist(
        (set, get) => ({
            selectedStateMenuUsers: 'users',
            setSelectedStateMenuUsers: (uid: string) => set({ selectedStateMenuUsers: uid }),
        }),
        {
            name: 'menu-users-state',
            partialize: (state) => ({ selectedStateMenuUsers: state.selectedStateMenuUsers }),
            onRehydrateStorage: () => (state) => {
                if (state) {
                    state.selectedStateMenuUsers = 'users';
                }
            },
        },
    ),
);